import { render, staticRenderFns } from "./consumables.vue?vue&type=template&id=7a6e6d40"
import script from "./consumables.vue?vue&type=script&lang=js"
export * from "./consumables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports